export function humanHours(minutes) {
  if (!minutes && minutes !== 0) return '—';
  const hours = minutes / 60;
  if (hours < 1) return `${Math.round(minutes)}m`;
  if (hours < 10) return `${hours.toFixed(1)}h`;
  return `${Math.round(hours)}h`;
}

// Month + year only ("Mar 2026") — for transcript-style "active since" ranges.
// Named formatMonthYear (not formatDateShort) on purpose: cognition's
// ScoreHistoryChart has its own local, differently-grained "short date"
// formatter (day-level, "Mar 14") for chart axis labels. Both used to be
// named formatDateShort, which meant importing "the wrong one" silently
// swapped "Mar 14" for "Mar 2026" with no error.
export function formatMonthYear(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
}

export function formatDateFull(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function masteryLabel(pct) {
  if (pct == null) return null;
  if (pct >= 90) return 'Mastered';
  if (pct >= 80) return 'Proficient';
  if (pct >= 70) return 'Developing';
  return 'Emerging';
}

export function masteryTone(pct) {
  if (pct == null) return 'neutral';
  if (pct >= 90) return 'success';
  if (pct >= 80) return 'accent';
  if (pct >= 70) return 'warning';
  return 'danger';
}
